import React, { useState, useRef } from 'react';
import classNames from 'classnames';
import { createPortal } from 'react-dom';
import translate from '../../utilities/translator';
import { parseDate } from '../../utilities/helpers';
import { addDays } from 'date-fns';
import format from '../../utilities/format';
import { pushEvent } from '../../utilities/analytics';
import { PRICE_GRAPH_SELECT_DATE } from '../../constants/analyticEvents';
import { getDisplayPrice } from '../../utilities/priceHelper';

function PriceGraphItem(props) {
  const {
    date,
    getProgress,
    scrollbooster,
    onApply,
    highlightActive = false,
    nights,
    selected,
    isActive,
  } = props;

  const itemRef = useRef(null);
  const [hovered, setHovered] = useState(false);
  const height = `${getProgress(date.avgPrice)}px`;
  const isMobile = window.innerWidth <= 768;

  const getScrollPosition = () => scrollbooster?.getState().position.x || 0;

  const getTooltipPosition = () => {
    const scrollPosition = getScrollPosition();
    let position = `translate(${(itemRef.current.offsetLeft - scrollPosition) + itemRef.current.offsetParent.offsetLeft - 18}px, ${itemRef.current.offsetTop + 85}px)`;
    if (document.dir === 'rtl') {
      position = `translate(${(itemRef.current.offsetLeft - itemRef.current.offsetParent.offsetParent.offsetWidth + itemRef.current.offsetParent.offsetLeft - getScrollPosition() + itemRef.current.offsetWidth + 15)}px, ${itemRef.current.offsetTop + 85}px)`;
    }

    return position;
  }

  const handleApplyClick = () => {
    const start = parseDate(date.start);
    const end = addDays(start, nights);

    onApply({ start, end });
    pushEvent(PRICE_GRAPH_SELECT_DATE, { start, end });
  }

  return (
    <div
      className={classNames('price-graph__item', {
        active: highlightActive && isActive,
        disabled: date.avgPrice === 0
      })}
      ref={itemRef}
      onMouseEnter={() => date.avgPrice !== 0 && setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <span className="price-graph__day">{format(parseDate(date.start), 'd')}</span>
      <span className="price-graph__month">{format(parseDate(date.start), 'EEEEEE')}</span>
      <div className={classNames('price-graph__bar', { selected } )} style={{ height }} />
      {date.flightWithStops && (
        <span className="price-graph__stops" />
      )}

      {!isMobile && hovered &&
        createPortal(
          <div
            className="price-graph__item--expanded"
            style={{
              position: 'absolute',
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
              transform: getTooltipPosition()
            }}
            onClick={handleApplyClick}
          >
            <span className="price-graph__day">{format(parseDate(date.start), 'd')}</span>
            <span className="price-graph__month">{format(parseDate(date.start), 'EEEEEE')}</span>
            <div className="price-graph__bar" style={{ height }}>
              {date.flightWithStops && (
                <span className="price-graph__stops" />
              )}
            </div>
            <div className="price-graph__price">
              <span className="price-from">{translate('holidayFinder.priceGraph.item_from')}</span>
              <div className="price-value">{getDisplayPrice(date.avgPrice)}</div>
            </div>
            <span className="price-graph__apply">{translate('holidayFinder.priceGraph.item_apply')}</span>
          </div>,
          document.querySelector('.list-wrap')
        )}
    </div>
  )
}

export default React.memo(PriceGraphItem)
